const isBlobLike = (value: unknown): value is Blob => {
  if (typeof Blob === "undefined") return false;
  return value instanceof Blob;
};

/**
 * Returns a usable URL for previewing a file.
 * - If `file.file` is a Blob/File, uses `URL.createObjectURL`.
 * - If a remote URL exists (`file.file.url` or `file.url`), returns it.
 * - Otherwise returns an empty string to avoid `URL.createObjectURL` crashes.
 */
export const getFileUrlForViewer = (file: any): string => {
  const maybeInner = file?.file;

  if (typeof file?.url === "string" && file.url.trim().length > 0) {
    return file.url;
  }
  if (maybeInner) {
    const remoteUrl = maybeInner?.url ?? file?.file?.url;
    if (typeof remoteUrl === "string" && remoteUrl.trim().length > 0) {
      return remoteUrl;
    }

    if (isBlobLike(maybeInner)) {
      return URL.createObjectURL(maybeInner);
    }
  }

  if (isBlobLike(file)) {
    return URL.createObjectURL(file);
  }

  return "";
};
